import { render, staticRenderFns } from "./industry-type.vue?vue&type=template&id=0dba533d&"
import script from "./industry-type.vue?vue&type=script&lang=js&"
export * from "./industry-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports